module.exports = {"searchRunner":{"ja":"ランナーを検索する","en":"Search Runner"},"placeholder":{"ja":"アプリのアカウント名 or エントリーID","en":"App profile name or Entry ID"},"search":{"ja":"検索","en":"Search"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/constants/ranking/userSearch.json
// module id = TFo7
// module chunks = 1